import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useTranslate } from "src/i18n/useTranslate"
import { Combobox } from "src/ui/Combobox/Combobox"

import { TMemberAccess } from "./memberAccessTypes"

interface IMemberAccessLevel {
  id: TMemberAccess
  label: string
  description: string
}

export function MemberAccessPicker({
  access,
  onChange,
}: {
  access: TMemberAccess | undefined
  onChange: (access: TMemberAccess) => void
}) {
  const { t, langKeys } = useTranslate()

  const { orgAccessLogic } = useOrganization()

  const accessLevelsAll: IMemberAccessLevel[] = [
    {
      id: "org-level-access",
      label: t(langKeys.organization_access_title),
      description: t(langKeys.organizations_access_all_homes_description),
    },
    {
      id: "homegroup-level-access",
      label: t(langKeys.organizations_homegroup_access_title),
      description: t(
        langKeys.organizations_homegroup_access_all_homes_description
      ),
    },
    {
      id: "home-level-access",
      label: t(langKeys.home_access_title),
      description: t(langKeys.home_access_single_home_description),
    },
  ]
  // Prevent non-org admins from selecting any organization level invites:
  const accessLevels = accessLevelsAll.filter((item) =>
    item.id === "org-level-access" && !orgAccessLogic.hasAdminAccess
      ? false
      : true
  )

  return (
    <Combobox
      input={accessLevels.find((level) => level.id === access)?.label ?? ""}
      label={t(langKeys.access_title)}
      selectedValue={access ?? ""}
      onChange={(value) => onChange(value as TMemberAccess)}
      options={accessLevels.map((level) => ({
        label: level.label,
        value: level.id,
        description: level.description,
      }))}
      onInput={() => {}}
    />
  )
}
